export default __webpack_public_path__ + "static/mar-crm-email-c61ac8b1c2934fbfaf0d0e9cafcbc59f.png";